import {
  Box,
  Button,
  Flex,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import GoogleIcon from "../primary/Icon";
import Logo from "./Logo";
import classes from "./Menu.module.scss";
import { menuItems } from "./MenuItems";
import SubMenu from "./SubMenu";

const Menu = () => {
  const [mobileDrawerOpen, setMobileMenuOpen] = useState(false);

  const onClose = () => setMobileMenuOpen(false);

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 1280 && mobileDrawerOpen) {
        setMobileMenuOpen(false);
      }
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [mobileDrawerOpen]);

  useEffect(() => {
    if (!mobileDrawerOpen) return;

    const originalOverflow = document.body.style.overflow;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = originalOverflow;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [mobileDrawerOpen]);

  return (
    <nav className={classes.bar}>
      <Logo />
      <Flex
        className={classes.links}
        alignItems="center"
        columnGap={8}
        display={{ base: "none", xl: "flex" }}
      >
        {menuItems.map((item, index) => (
          <SubMenu key={index} item={item} onClose={onClose} />
        ))}
      </Flex>

      <Button
        aria-label="Open Menu"
        size="lg"
        mr={2}
        onClick={() => setMobileMenuOpen(true)}
        display={{ base: "block", xl: "none" }}
        variant="link"
      >
        <GoogleIcon name="menu" fontSize={38} color="preview.primary" />
      </Button>

      {mobileDrawerOpen && (
        <Box className={classes.overlay} onClick={onClose}>
          <Box
            aria-label="Site menu"
            aria-modal="true"
            className={classes.drawer}
            onClick={(event) => event.stopPropagation()}
            role="dialog"
          >
            <Box className={classes.drawerHeader}>
              <Button aria-label="Close Menu" onClick={onClose} variant="ghost">
                <GoogleIcon name="close" fontSize={28} />
              </Button>
            </Box>
            <Box className={classes.drawerBody}>
              <Flex
                flexDirection="column"
                className={classes.links}
                display={{ base: "flex", xl: "none" }}
              >
                {menuItems.map((item, index) => (
                  <SubMenu key={index} item={item} onClose={onClose} />
                ))}
              </Flex>
            </Box>
            <Box className={classes.drawerFooter}>@ CLE 2026</Box>
          </Box>
        </Box>
      )}
    </nav>
  );
};

export default Menu;
